import { FeatureFlagsEnum } from '@/store/slices/feature-flags/types';

// add toggle-able flags to this map
const featureFlagKeyMap: Record<string, FeatureFlagsEnum> = {
  Digit2: FeatureFlagsEnum.template_library,
  Digit3: FeatureFlagsEnum.preview_template,
  Digit4: FeatureFlagsEnum.create_wizard,
  Digit5: FeatureFlagsEnum.project_details,
  Digit6: FeatureFlagsEnum.series,
  // Important: Do not use the KeyT because on windows machines "alt + shift + t" is a reserved hotkey for the back arrow
};

export default featureFlagKeyMap;
